<div class="my-24 flex flex-col gap-24 p-4 md:my-28 md:gap-28">
  <!-- Form -->
  <app-android-keystore-generator-form-section id="form" />
  <!-- Info -->
  <app-android-keystore-generator-info-section />
  <!-- FAQ -->
  <app-android-keystore-generator-faq-section />
  <!-- CTA -->
  <app-cta-section id="cta" />
</div>
